<template>
  <v-app :class="displayClasses">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import displayMixin from "@/mixins/display";

export default {
  name: "App",
  mixins: [displayMixin],
  data: () => ({
    //
  })
};
</script>
<style lang="scss">
#app {
  font-family: "Open Sans", sans-serif;
  min-width: 250px;
  background-color: white;
  overflow-x: hidden;
}

.v-input.v-input--error {
  .v-label,
  .v-field__prepend-inner,
  .v-field__append-inner,
  .v-text-field__prefix__text,
  .v-text-field__suffix__text,
  .v-messages__message {
    color: rgb(var(--v-theme-error)) !important;
  }
  .v-field .v-field__outline::before,
  .v-field .v-field__outline::after {
    border-color: rgb(var(--v-theme-error)) !important;
  }
}

button {
  &.v-btn{
    border-radius: 23.5px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.21px;
    &.large{
      border: solid 2px rgb(var(--v-theme-primary));

      &:not(.v-btn--icon).v-btn--size-default {
        height: 47px;
        min-width: 165px;
      }
    }
  }

  &.v-btn {
    color: rgb(var(--v-theme-primary));

    &:not(.v-btn--variant-flat):not(.v-btn--variant-plain):not(.v-btn--variant-outlined) {
      background: white;
    }

    &.v-btn--variant-elevated {
      box-shadow: #0000001f 0px 17px 16px -12px;
    }
  }
}
</style>
